/**
 * Returns the first argument that is not `undefined`.
 */
export function getFirstDefined<T>(...items: (T | undefined)[]): T | undefined {
    for (let i = 0; i < items.length; i++) {
        if (items[i] !== undefined) {
            return items[i];
        }
    }
    return undefined;
}
